var BookCover = require("components/reading/books/BookCover");

require("reading/shelves/book_sidebar.scss")

class BookSidebar extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	selectBook(text_id) {
		if (this.props.onBookSelect) {
			this.props.onBookSelect(text_id);
		}
	}

	render() {
		var sortedBooks = $wr.sortByName(this.props.books, "bookTitle");
		var smallBooks = _.map(sortedBooks, function(book) {
			if (this.props.selectedTextID == book.text_id) {
				var className = " selectedBook"
			} 
			return (
				<div className={ "bookContainer book" + book.text_id + className } key={ book.text_id }
					onClick={ this.selectBook.bind(this, book.text_id) }>

					<BookCover book={ book } coverWidth={ 50 }
						showTitle={ true } showAuthor={ false } />	
				</div>
			);
		}.bind(this));
		return (
			<div className="bookSidebar">
				{ smallBooks }
			</div>
		)
	}
}

BookSidebar.propTypes = StrictPropTypes({
	books: PropTypes.array.isRequired,

	selectedTextID: PropTypes.string,

	onBookSelect: PropTypes.func
});


module.exports = BookSidebar;


// WEBPACK FOOTER //
// ./modules/components/reading/shelves/BookSidebar.js